import React, { useState } from "react";
import { Download, CheckCircle, Clock, FileText, Star, User2Icon, TrendingUp, StarsIcon, Loader } from "lucide-react";
import { useDispatch, useSelector } from "react-redux";
import axios from "../../axios";
import BrochureModal from "../Program/BrochureModal";
import { Image, Shimmer } from "react-shimmer";

const ratings = new Map();
ratings.set("Data Science", 4.53);
ratings.set("Data Analytics", 4.60);
ratings.set("Business Analytics", 4.41);
ratings.set("Digital Marketing", 4.18);
ratings.set("Cyber Security", 4.82);
ratings.set("Data Engineering", 4.50);
ratings.set("DevOps Engineering", 4.70);
ratings.set("Project Management", 4.32);



const Brochure = () => {
  const dispatch = useDispatch();
  const [showToast, setShowToast] = useState(false);
  const [downloadedFile, setDownloadedFile] = useState("");
  const [modalShow, setModalShow] = useState(false);
  const allPrograms = useSelector((state) => state.courseData.allprograms);
  const [programData, setProgramData] = useState(null);
  const [loading, setLoading] = useState(null);


  const handleDownload = async (brochure) => {
    try {
      setLoading(brochure._id);
      const url = `/course/page_data/${brochure._id}/`;
      const res = await axios.get(url);
      const { data } = res.data;
      setProgramData(data);
      setModalShow(true);
    } catch (error) {
      console.log(error)
    } finally {
      setLoading(null);
    }
  };

  return (
    <>
      <style jsx>{`
        body {
          background: linear-gradient(135deg, #f6f8ff 0%, #f1f4ff 100%);
          min-height: 100vh;
          font-family: "Inter", sans-serif;
        }

        .brochure-card {
          border: none;
          border-radius: 24px;
          overflow: hidden;
          box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
          transition: all 0.4s cubic-bezier(0.165, 0.84, 0.44, 1);
          position: relative;
          background: white;
          display: flex;
          flex-direction: column;
          height: 100%;
          backdrop-filter: blur(10px);
        }

        .brochure-card:hover {
          transform: translateY(-8px);
          box-shadow: 0 20px 40px rgba(0, 0, 0, 0.12);
        }

        .card-img-top {
          height: 240px;
          object-fit: cover;
          width: 100%;
          position: relative;
        }

        .badge {
          position: absolute;
          top: 16px;
          left: 16px;
          background: rgba(79, 70, 229, 0.9);
          color: white;
          padding: 6px 12px;
          border-radius: 20px;
          font-size: 12px;
          font-weight: 600;
          z-index: 1;
        }

        .rating {
          position: absolute;
          top: 16px;
          right: 16px;
          background: rgba(255, 255, 255, 0.9);
          color: #4f46e5;
          padding: 6px 12px;
          border-radius: 20px;
          font-size: 12px;
          font-weight: 600;
          display: flex;
          align-items: center;
          gap: 4px;
          z-index: 1;
        }

        .card-body {
          padding: 24px;
          flex-grow: 1;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
        }

        .card-title {
          font-size: 20px;
          font-weight: 700;
          color: #1a1f36;
          margin-bottom: 12px;
          line-height: 1.4;
        }

        .card-description {
          color: #4f566b;
          font-size: 15px;
          line-height: 1.6;
          margin-bottom: 20px;
          flex-grow: 1;
        }

        .card-meta {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding-top: 16px;
          border-top: 1px solid #e9ecef;
          font-size: 13px;
          color: #6b7280;
        }

        .meta-item {
          display: flex;
          align-items: center;
          gap: 6px;
        }

        .download-btn {
          background: linear-gradient(135deg, #fff 0%, aliceblue 100%);
          border: none;
          box-shadow: rgba(0, 0, 0, 0.02) 0px 1px 3px 0px, rgba(27, 31, 35, 0.15) 0px 0px 0px 1px;
          color: #000;
          padding: 14px 28px;
          border-radius: 8px;
          font-weight: 600;
          font-size: 16px;
          display: flex;
          align-items: center;
          gap: 10px;
          cursor: pointer;
          width: 100%;
          justify-content: center;
          margin-top: 20px;
          transition: all 0.1s ease;
        }

        .download-btn:hover {
          background: linear-gradient(135deg, #4338ca 0%, #3730a3 100%);
          transform: translateY(-2px);
          color: #fff;
        }

        .container-fluid {
          max-width: 1400px;
          margin: 0 auto;
          padding: 60px 30px;
        }

        .section-header {
          text-align: center;
          margin-bottom: 50px;
        }

        .section-title {
          font-size: 36px;
          font-weight: 800;
          color: #1a1f36;
          margin-bottom: 16px;
        }

        .section-subtitle {
          font-size: 18px;
          color: #4f566b;
          max-width: 600px;
          margin: 0 auto;
          line-height: 1.6;
        }

        .row {
          display: flex;
          flex-wrap: wrap;
          margin: -16px;
        }

        .col {
          flex: 1 1 33.333%;
          max-width: 33.333%;
          padding: 16px;
          margin-bottom: 30px;
        }

        @media (max-width: 1200px) {
          .col {
            flex: 1 1 50%;
            max-width: 50%;
          }
        }

        @media (max-width: 768px) {
          .col {
            flex: 1 1 100%;
            max-width: 100%;
          }

          .section-title {
            font-size: 28px;
          }

          .section-subtitle {
            font-size: 16px;
          }

          .card-img-top {
            height: 200px;
          }
        }

        .fade-in {
          animation: fadeIn 0.8s cubic-bezier(0.165, 0.84, 0.44, 1);
        }

        @keyframes fadeIn {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        .toast {
          position: fixed;
          bottom: 30px;
          right: 30px;
          z-index: 1055;
          background: white;
          border-radius: 16px;
          box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);
          padding: 20px 24px;
          display: flex;
          align-items: center;
          gap: 16px;
          min-width: 320px;
          animation: slideUp 0.4s cubic-bezier(0.165, 0.84, 0.44, 1);
        }

        @keyframes slideUp {
          from {
            opacity: 0;
            transform: translateY(100%);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        .toast-header {
          display: flex;
          align-items: center;
          gap: 10px;
          font-weight: 700;
          color: #10b981;
        }

        .toast-body {
          color: #4f566b;
          font-size: 15px;
          margin-top: 4px;
        }

        /* Rest of the styles remain the same */
      `}</style>

      <div className="container-fluid">

        <div className="section-header">
          <h1 className="section-title">Download Program Brochures</h1>
          <p className="section-subtitle">
            Access our collection of program brochures and
            reports
          </p>
        </div>

        {modalShow && (
          <BrochureModal
            modalShow={modalShow}
            setModalShow={setModalShow}
            pdfUrl={programData?.program_pdf}
            program={programData?.program_advisor_department}
          />
        )}

        <div className="row">
          {allPrograms.filter(item => !( item.slug === "digital-marketing-program")).map((brochure, index) => (
            <div key={brochure.id} className="col">
              <div
                className="brochure-card fade-in"
                style={{ animationDelay: `${index * 0.1}s` }}
              >
                <div style={{ position: "relative" }}>
                  {/* <img
                    src={brochure.image}
                    className="card-img-top"
                    alt={brochure.title}
                  /> */}
                  <Image
                    NativeImgProps={{width:"100%", height:"240px", alt:brochure.title, style:{objectFit:"cover"}}}
                    src={brochure.image}
                    fadeIn={true}
                    fallback={<Shimmer height={280} className="w-100 mt-4" />}
                  />
                  <span className="badge">{index === 0 ? <span> <StarsIcon size={16} /> {"Bestseller"}</span> : index === 1 ? <span> <TrendingUp size={16} /> {"Bestseller"}</span> : brochure.title === "Cyber Security" ? <span> <TrendingUp size={16} /> {"Bestseller"}</span> : "Training Program"}</span>
                  <span className="rating">
                    <Star enableBackground="#FFC107" size={14} />
                    {ratings.get(brochure.title)}
                  </span>
                </div>
                <div className="card-body">
                  <h5 className="card-title">{brochure.title}</h5>
                  <p className="card-description">{brochure.description}</p>
                  <div className="card-meta">
                    <div className="meta-item">
                      <User2Icon size={16} />
                      {brochure.title.includes("Cyber Security") ? "4.1k downloads" :
                        brochure.title.includes("Data Science") ? "8.3k downloads" :
                          brochure.title.includes("Data Analytics") ? "5.7k downloads" :
                            brochure.title.includes("Business Analytics") ? "3.2k downloads" :
                              brochure.title.includes("Digital Marketing") ? "1.8k downloads" :
                                brochure.title.includes("DevOps") ? "6.4k downloads" :
                                  brochure.title.includes("Data Engineering") ? "2.1k downloads" :
                                    "1.3k downloads"}
                    </div>
                    <div className="meta-item">
                      <Clock size={16} />
                      {"3 Months"}
                    </div>
                  </div>
                  <button
                    className="download-btn"
                    onClick={() => handleDownload(brochure)}
                  >
                    {loading === brochure._id ? <Loader size={20} /> : <Download size={20} />}
                    {loading === brochure._id ? "Please Wait" : "Download Brochure"}
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {showToast && (
        <div className="toast">
          <div>
            <div className="toast-header">
              <CheckCircle size={22} />
              <strong>Download Initiated</strong>
            </div>
            <div className="toast-body">
              {downloadedFile} will be ready in a moment
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Brochure;
